import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FUEL_VOUCHER_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import FuelVoucherForm from './FuelVoucherForm';
import { postExtraordinaryFuelVoucher } from '../../../../actions';
import Content from '../../../layout/Content';
import { getSubstring } from '../../../../utils/string';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT, TIME_FORMAT } from '../../../../config/locale';

export class NewFuelVoucher extends Component {
  onSubmit = (formValues) => {
    const { dispatchPostExtraordinaryFuelVoucher } = this.props;

    const validFrom = tzNormalizeDate({
      date: formValues.validFrom,
      format: INT_DATE_FORMAT,
    });

    const validTo = tzNormalizeDate({
      date: formValues.validTo,
      format: INT_DATE_FORMAT,
    });

    const validFromHour = formValues.validFromHour
      ? tzNormalizeDate({
          date: formValues.validFromHour,
          format: TIME_FORMAT,
        })
      : null;

    const validToHour = formValues.validToHour
      ? tzNormalizeDate({
          date: formValues.validToHour,
          format: TIME_FORMAT,
        })
      : null;
    
    const validFromDate = validFromHour
      ? tzNormalizeDate({
          date: `${validFrom} ${validFromHour}`,
        })
      : formValues.validFrom;

    const validToDate = validToHour
      ? tzNormalizeDate({
          date: `${validTo} ${validToHour}`,
        })
      : formValues.validTo;

    const postFuelVoucherFormValues = {
      validFrom: validFromDate,
      validTo: validToDate,
      companyBusId: formValues.companyBusId,
      fuelReceiverName: formValues.fuelReceiverName,
      numberOfGallons: formValues.numberOfGallons,
      itineraryId: getSubstring(formValues.itineraryId),
      fuelStationId: formValues.fuelStationId
        ? formValues.fuelStationId.value
        : null,
      comments: formValues.comments,
    };
    dispatchPostExtraordinaryFuelVoucher(postFuelVoucherFormValues);
  };

  render() {
    return (
      <Content
        breadcrumbs={this.props.breadcrumbs}
        title="Nuevo Vale de Combustible Extraordinario"
        subtitle="Crear nuevo vale de combustible extraordinario"
        content={<FuelVoucherForm onSubmit={this.onSubmit} />}
      />
    );
  }
}

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Vales de Combustible',
      href: FUEL_VOUCHER_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostExtraordinaryFuelVoucher: postExtraordinaryFuelVoucher,
};

NewFuelVoucher.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostExtraordinaryFuelVoucher: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewFuelVoucher);
